// extracted by mini-css-extract-plugin
module.exports = {"component":"video-media-block_component__vhzWP","column":"video-media-block_column__LQTPx","video":"video-media-block_video__kpbyL","caption":"video-media-block_caption__RfOZ3"};